import React from "react";
import { chatWithLlm } from "../api";
import Grid from "./../components/Grid/Grid";
import { GlobalContext } from "../context/GlobalContext";
import { useAuth } from "../context/AuthContext";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

function Chatbot() {
  //* init
  const { isMobile } = React.useContext(GlobalContext);
  const { currentUser } = useAuth();

  //* states
  const [messages, setMessages] = React.useState([
    {
      role: "assistant",
      content: `Hi ${currentUser.name}, wie kann ich dir helfen?`,
    },
  ]);
  const [input, setInput] = React.useState("");

  //* refs
  const chatRef = React.useRef(null);
  const textareaRef = React.useRef(null);

  //* fucntions
  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: "user", content: input }];

    setMessages(newMessages);
    setInput("");

    setTimeout(() => {
      chatRef.current?.scrollTo({
        top: chatRef.current.scrollHeight,
        behavior: "smooth",
      });
    }, 100);

    // 🔥 Reset textarea height
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current?.blur();
    }

    try {
      const res = await chatWithLlm(newMessages);

      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: res.response },
      ]);
    } catch (err) {
      console.error(err);
    }
  };

  //* useEffects
  React.useEffect(() => {
    //* auto scroll chat
    chatRef.current?.scrollTo({
      top: chatRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages]);

  return (
    <>
      <Grid>
        <div
          className={`col-12 bg-dark ${isMobile ? "chatbot-mobile" : "chatbot"}`}
        >
          {/* CHAT AREA */}
          <div
            id="chat-scroll"
            className="chatbot-chat-container"
            ref={chatRef}
          >
            {messages.length === 0 && (
              <div className="chatbot-chat-placeholder text-muted">
                Wie kann ich dir helfen?
              </div>
            )}

            {messages.map((msg, i) => (
              <div
                key={i}
                className={`${msg.role === "user" ? "chatbot-chat-message-user" : "chatbot-chat-message-assistant"}`}
              >
                <div
                  className={`chatbot-chat-message ${msg.role === "user" ? "chatbot-chat-message-user-bubble" : "bg-light"}`}
                >
                  {parse(msg.content)}
                </div>
              </div>
            ))}
          </div>

          {/* INPUT AREA */}
          <div className="chatbot-input-container">
            <textarea
              className="chatbot-input-textarea"
              ref={textareaRef}
              value={input}
              rows={1}
              onChange={(e) => {
                setInput(e.target.value);

                // auto grow max 5 rows
                e.target.style.height = "auto";
                e.target.style.height =
                  Math.min(e.target.scrollHeight, 120) + "px";
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                }
              }}
              placeholder="Wie kann ich dir helfen?"
            />

            <button
              className="chatbot-chat-message-user-bubble chatbot-input-button text-dark"
              onClick={handleSend}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
            </button>
          </div>
        </div>
      </Grid>
    </>
  );
}

export default Chatbot;
